import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'ridango-progress-v2',
    templateUrl: './progress-v2.component.html',
    styleUrls: ['./progress-v2.component.css']
})
export class ProgressV2Component implements OnInit {
    @Input() steps = [];
    @Input() activeStep = 0;


    ngOnInit() {
    }

}
